// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Navbar Logo ===== */
.navbar-logo {
  display: flex;
  align-items: center;
  font-family: 'Outfit', 'Inter', sans-serif;
  -webkit-user-select: none;
          user-select: none;
  padding: 4px 10px;
  margin: 0;
  gap: 2px;
}

.logo-text {
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  transition: opacity 0.2s ease;
}

.logo-bold {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-left: 4px;
  transition: opacity 0.2s ease;
}

/* Gradient text for logged-in state */
.logo-gradient {
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo-dark {
  color: #1a1a2e;
  -webkit-text-fill-color: #1a1a2e;
}

/* White text for logged-out state */
.logo-white {
  color: #ffffff;
  -webkit-text-fill-color: #ffffff;
}

@media (max-width: 600px) {
  .logo-text {
    font-size: 1rem;
  }
  .logo-bold {
    font-size: 1.05rem;
  }
}

/* ===== Search Input ===== */
.navbar-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.875rem;
  color: #374151;
  width: 100%;
  padding: 4px 0;
  font-family: 'Inter', 'Outfit', sans-serif;
}

.navbar-search-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

/* ===== Login Button (logged-out) ===== */
.navbar-button {
  font-size: 0.85rem;
  padding: 6px 20px;
  min-height: 36px;
}

/* ===== Dropdown (legacy / mobile) ===== */
.navbar-dropdown {
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #eef0f6;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  z-index: 1000;
  min-width: 220px;
  font-size: 13px;
}

.navbar-dropdown > div {
  padding: 8px 14px;
}

.navbar-dropdown > div:not(:last-child) {
  border-bottom: 1px solid #eef0f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Navbar.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0EAA0E;EAC1E,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* ===== Navbar Logo ===== */\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  font-family: 'Outfit', 'Inter', sans-serif;\n  user-select: none;\n  padding: 4px 10px;\n  margin: 0;\n  gap: 2px;\n}\n\n.logo-text {\n  font-size: 1.2rem;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  transition: opacity 0.2s ease;\n}\n\n.logo-bold {\n  font-size: 1.2rem;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  margin-left: 4px;\n  transition: opacity 0.2s ease;\n}\n\n/* Gradient text for logged-in state */\n.logo-gradient {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.logo-dark {\n  color: #1a1a2e;\n  -webkit-text-fill-color: #1a1a2e;\n}\n\n/* White text for logged-out state */\n.logo-white {\n  color: #ffffff;\n  -webkit-text-fill-color: #ffffff;\n}\n\n@media (max-width: 600px) {\n  .logo-text {\n    font-size: 1rem;\n  }\n  .logo-bold {\n    font-size: 1.05rem;\n  }\n}\n\n/* ===== Search Input ===== */\n.navbar-search-input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.875rem;\n  color: #374151;\n  width: 100%;\n  padding: 4px 0;\n  font-family: 'Inter', 'Outfit', sans-serif;\n}\n\n.navbar-search-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n/* ===== Login Button (logged-out) ===== */\n.navbar-button {\n  font-size: 0.85rem;\n  padding: 6px 20px;\n  min-height: 36px;\n}\n\n/* ===== Dropdown (legacy / mobile) ===== */\n.navbar-dropdown {\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #eef0f6;\n  border-radius: 16px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);\n  z-index: 1000;\n  min-width: 220px;\n  font-size: 13px;\n}\n\n.navbar-dropdown > div {\n  padding: 8px 14px;\n}\n\n.navbar-dropdown > div:not(:last-child) {\n  border-bottom: 1px solid #eef0f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
